import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import FloatingCTA from "./components/FloatingCTA";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ExportDeck from "./pages/ExportDeck";
import Contact from "./pages/Contact";

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/export-deck" element={<ExportDeck />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <FloatingCTA />
    </BrowserRouter>
  );
}
